import React from "react";

function FlWrapper({ children, isActive, handleClick }) {
    return (
        <li className="fl" onClick={handleClick}>
            {children}
        </li>
    );
}

export default FlWrapper;
